import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

import { Formik } from 'formik';
import * as Yup from 'yup';

import { authApi } from '@reducers/auth';

const schema = Yup.object({
  email: Yup.string().email().required().label('Email'),
});

export const ResetPasswordForm = () => {
  const [trigger, { isLoading }] = authApi.useResetPasswordMutation();
  const onSubmit = async (values, actions) => {
    trigger(values)
      .unwrap()
      .catch(({ data }) => actions.setFieldError('email', data.detail));
  };

  return (
    <Formik
      enableReinitialize
      validationSchema={schema}
      initialValues={{ email: '' }}
      onSubmit={onSubmit}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        values,
        touched,
        errors,
      }) => (
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-1" controlId="form.email">
            <Row>
              <Form.Label column sm="4">
                Email
              </Form.Label>
            </Row>
            <Row>
              <Col>
                <Form.Control
                  type="text"
                  name="email"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  isValid={touched.email && !errors.email}
                  isInvalid={touched.email && errors.email}
                  placeholder="email@example.com"
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Col>
            </Row>
          </Form.Group>
          <Row className="mt-2">
            <Col>
              Please write your e-mail address and check your inbox for the
              reset password link.
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <Button
                className="w-100 mt-2"
                variant="didxl"
                size="sm"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                Reset password
              </Button>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};
